const toNumber = (value: any) => {
  const number = Number(value);
  return isNaN(number) ? 0 : number;
};

const getSalaryDebitAmount = (fileInfo: any) => toNumber(fileInfo?.total_amount) + toNumber(fileInfo?.fee_amount);

const isBalanceEnough = (balance: any, amount: number) => {
  if (balance === null || balance === undefined || balance === '') {
    return false;
  }

  const number = Number(balance);

  return !isNaN(number) && number >= amount;
};

export { getSalaryDebitAmount, isBalanceEnough };
